"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SdkExtension_1 = __importDefault(require("@rc-ex/core/lib/SdkExtension"));
const RestException_1 = __importDefault(require("@rc-ex/core/lib/RestException"));
class RcSdkExtension extends SdkExtension_1.default {
    constructor(options) {
        super();
        this.options = options;
    }
    async install(rc) {
        Object.defineProperty(rc, 'token', {
            get: async () => this.options.rcSdk.platform().auth().data(),
        });
        const request = rc.request.bind(rc);
        rc.request = async (method, endpoint, content, queryParams, config) => {
            if (!this.enabled) {
                return request(method, endpoint, content, queryParams, config);
            }
            const r = await this.options.rcSdk.send({
                method,
                url: endpoint,
                body: content,
                query: queryParams,
                headers: config === null || config === void 0 ? void 0 : config.headers,
            });
            const response = {
                data: await r.json(),
                status: r.status,
                statusText: r.statusText,
                headers: r.headers,
                config: {
                    method,
                    baseURL: r.url.split(endpoint)[0],
                    url: endpoint,
                    data: content,
                    params: queryParams,
                },
            };
            if (r.ok) {
                return response;
            }
            throw new RestException_1.default(response);
        };
    }
    // eslint-disable-next-line class-methods-use-this, @typescript-eslint/no-empty-function
    async revoke() { }
}
exports.default = RcSdkExtension;
//# sourceMappingURL=index.js.map